import { Check } from "lucide-react";
import { cn } from "@/lib/utils";
import { STEP_LABELS } from "./types";

interface ProgressRailProps {
  current: number;
  total?: number;
  labels?: string[];
}

export function ProgressRail({ current, total = 7, labels }: ProgressRailProps) {
  const stepLabels = labels ?? STEP_LABELS;

  return (
    <div className="px-6 py-4 border-b border-border/50 bg-background shrink-0">
      <div className="flex items-start">
        {stepLabels.map((label, i) => {
          const stepNum = i + 1;
          const done = stepNum < current;
          const active = stepNum === current;
          const isLast = i === stepLabels.length - 1;

          return (
            <div key={label} className={cn("flex items-center", !isLast && "flex-1")}>
              <div className="flex flex-col items-center gap-1.5 shrink-0">
                <div
                  className={cn(
                    "flex h-5 w-5 items-center justify-center rounded-full text-label font-semibold transition-all duration-300",
                    done
                      ? "bg-blue-600 text-white shadow-sm shadow-blue-600/30"
                      : active
                      ? "border-[1.5px] border-blue-500 text-blue-400 bg-background ring-2 ring-blue-500/12"
                      : "border border-border/60 text-subtle-foreground bg-background"
                  )}
                >
                  {done ? <Check className="h-2.5 w-2.5 stroke-[3]" /> : stepNum}
                </div>
                <span
                  className={cn(
                    "hidden sm:block text-label-xs font-medium leading-none whitespace-nowrap",
                    active
                      ? "text-blue-400"
                      : done
                      ? "text-subtle-foreground"
                      : "text-subtle-foreground"
                  )}
                >
                  {label}
                </span>
              </div>

              {!isLast && (
                <div className="flex-1 mx-1.5 mt-[-11px] h-px bg-border/40 relative overflow-hidden rounded-full">
                  <div
                    className="absolute inset-y-0 left-0 bg-blue-600 transition-all duration-500 ease-out"
                    style={{ width: done ? "100%" : "0%" }}
                  />
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
